import React, { useEffect, useState } from "react";
import "../../profile.css";
import { useNavigate } from "react-router-dom";

import service from "../../services/service";
import endpoints from "../../services/endpoints";

const MissionCard = ({ item, navigate }) => {
  return (
    <div className="mission-card">
      <div className="mission-header">
        <div className="mission-left">
          <div className="mission-logo">
            <img src="/challenge_icon.svg" alt="strava" />
          </div>

          <div>
            <h3>{item.challengeName}</h3>

            <p>{item.progressPercentage?.toFixed(2) || 0}% Completed</p>
          </div>
        </div>

        <span
          className={`mission-status ${
            item.status === "IN_PROGRESS"
              ? "mission-started"
              : item.status === "COMPLETED"
                ? "mission-completed"
                : item.status === "PAUSED"
                  ? "mission-paused"
                  : ""
          }`}
        >
          {item.status}
        </span>
      </div>

      <div className="mission-stats">
        <div>
          <span>Completed Distance</span>
          <h4>{item.completedDistance} KM</h4>
        </div>

        <div>
          <span>Total Distance</span>
          <h4>{item.totalDistance} KM</h4>
        </div>
      </div>

      <button
        className="view-map-btn"
        onClick={() => navigate(`/all-challenges/mission/${item.challengeId}`)}
      >
        View Map
      </button>
    </div>
  );
};

const AllChallenges = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [ongoingMissions, setOngoingMissions] = useState([]);
  const [completedMissions, setCompletedMissions] = useState([]);

  /* =========================
      GET MY CHALLENGES
  ========================= */

  const fetchMyChallenges = async () => {
    try {
      setLoading(true);

      const response = await service.get(endpoints.profile.myChallenges);

      const data = response?.data?.data;

      setOngoingMissions(data?.ongoingMissions || []);
      setCompletedMissions(data?.completedMissions || []);
    } catch (error) {
      console.error("My Challenges Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyChallenges();
  }, []);

  return (
    <div className="all-challenges-page">
      <h2 className="all-challenges-title">All Challenges</h2>

      {loading ? (
        <p style={{ color: "#fff" }}>Loading challenges...</p>
      ) : (
        <>
          {/* Ongoing Missions */}

          <div className="challenge-section">
            <h3>Ongoing Missions</h3>

            {ongoingMissions?.length > 0 ? (
              <div className="missions-grid">
                {ongoingMissions.map((item) => (
                  <MissionCard
                    key={item.challengeId}
                    item={item}
                    navigate={navigate}
                  />
                ))}
              </div>
            ) : (
              <p style={{ color: "#fff" }}>No ongoing missions found.</p>
            )}
          </div>

          {/* Completed Missions */}

          <div className="challenge-section">
            <h3>Completed Missions</h3>

            {completedMissions?.length > 0 ? (
              <div className="missions-grid">
                {completedMissions.map((item) => (
                  <MissionCard
                    key={item.challengeId}
                    item={item}
                    navigate={navigate}
                  />
                ))}
              </div>
            ) : (
              <p style={{ color: "#fff" }}>No completed missions found.</p>
            )}
          </div>

          {ongoingMissions.length === 0 && completedMissions.length === 0 && (
            <p style={{ color: "#fff" }}>No challenges found.</p>
          )}
        </>
      )}
    </div>
  );
};

export default AllChallenges;
